/**
 * ErrorListItemIcon  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { DOC_ERROR_SEVERITY } from "@adapptio/lib-blueprint";
import { Icon, ICON_SIZE } from "../Icon";

export interface IErrorListItemIconProps {
	severity: DOC_ERROR_SEVERITY;
}

const severityIcons: Record<DOC_ERROR_SEVERITY, string> = {
	[DOC_ERROR_SEVERITY.ERROR]: "mdi/alert-circle",
	[DOC_ERROR_SEVERITY.WARNING]: "mdi/alert",
	[DOC_ERROR_SEVERITY.INFO]: "mdi/information",
	[DOC_ERROR_SEVERITY.HINT]: "mdi/message-alert"
};

const severityValues: Record<DOC_ERROR_SEVERITY, string> = {
	[DOC_ERROR_SEVERITY.ERROR]: "error",
	[DOC_ERROR_SEVERITY.WARNING]: "warning",
	[DOC_ERROR_SEVERITY.INFO]: "info",
	[DOC_ERROR_SEVERITY.HINT]: "hint"
};

export const ErrorListItemIcon = React.memo<IErrorListItemIconProps>(({ severity }) => {
	const baseClass = BEM("edt-error-list", "item-icon", { severity: severityValues[severity] || severity });
	const iconName = severityIcons[severity];

	return <Icon className={baseClass.toClassName()} name={iconName} size={ICON_SIZE.XSMALL} />;
});

ErrorListItemIcon.displayName = "ErrorListItemIcon";
